import { FC, useRef } from 'react';
import { Flex } from 'antd';
import {
  SDropdown,
  ErrorMessage,
  SLabelTitle,
  SMailSelector,
  ModalDialog,
  StatusDropdown,
  UploadButton,
  SInput,
  SDatePicker,
  STextArea,
} from '../..';
import { IProps } from './type';
import globalStyles from '../../../assets/styles/index.module.scss';
import dayjs from 'dayjs';
import { useAppSelector } from '../../../store';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { DATE_FORMAT } from '../../../assets/conts';
import { modalTypes } from '../../../assets/enums';
import { useSetOrganizationOnOpen } from '../../../hooks';

dayjs.extend(customParseFormat);

const AbroadInsuranceModal: FC<IProps> = (props) => {
  const { getFieldProps, setFieldValue, values, errors, touched } =
    props.formik;
  const uploadInput = useRef<HTMLInputElement | null>(null);
  const { organization } = useAppSelector(
    (state) => state.userReducer.userInfo,
  );

  useSetOrganizationOnOpen(props.open, values, setFieldValue);

  return (
    <ModalDialog
      title={props.title}
      subTitle={props.subTitle}
      open={props.open}
      handleOk={props.handleSubmit}
      handleCancel={props.handleCancel}
    >
      <Flex gap="middle" vertical>
        <Flex align="flex-start" justify="space-between">
          <SLabelTitle>Şirket Bilgileri</SLabelTitle>
          <Flex vertical gap="small">
            <SDropdown
              id="organization"
              value={
                props.organizations.find(
                  (item) =>
                    item.id ===
                    (values.organization ||
                      (organization !== 1 ? organization : undefined)),
                )?.name
              }
              placeholder="Şirket Seçiniz"
              className={globalStyles.width200px}
              disabled={organization !== 1}
              options={props.organizations.map((item) => ({
                value: item.id,
                label: item.name,
              }))}
              onChange={(value) => setFieldValue('organization', value)}
            />
            {touched.organization && errors.organization && (
              <ErrorMessage>{errors.organization}</ErrorMessage>
            )}
          </Flex>
        </Flex>
        <Flex gap="small" vertical>
          <SLabelTitle>Poliçe Bilgileri</SLabelTitle>
          <Flex justify="space-between">
            <Flex vertical gap="small" className={globalStyles.widthOneThird}>
              <SInput
                placeholder="Poliçe No"
                {...getFieldProps('policy_number')}
              />
              {touched.policy_number && errors.policy_number && (
                <ErrorMessage>{errors.policy_number}</ErrorMessage>
              )}
            </Flex>
            <Flex vertical gap="small" className={globalStyles.widthOneThird}>
              <SDropdown
                id="branch"
                value={values.branch}
                placeholder="Branş"
                options={props.branches.map((b) => ({
                  value: b.key,
                  label: b.value,
                }))}
                onChange={(value) => setFieldValue('branch', value)}
              />
              {touched.branch && errors.branch && (
                <ErrorMessage>{errors.branch}</ErrorMessage>
              )}
            </Flex>
            <Flex vertical gap="small" className={globalStyles.widthOneThird}>
              <SDropdown
                id="country"
                value={values.country}
                placeholder="Ülke"
                options={props.countries.map((c) => ({
                  value: c.key,
                  label: c.value,
                }))}
                onChange={(value) => setFieldValue('country', value)}
              />
              {touched.country && errors.country && (
                <ErrorMessage>{errors.country}</ErrorMessage>
              )}
            </Flex>
          </Flex>
        </Flex>
        <UploadButton
          fileName={[...values.upload_files]?.map((item) => item.name)}
          uploadRef={uploadInput}
          onChange={props.handleUploadFile}
        />
        <Flex gap="small" vertical>
          <SLabelTitle>Tarih Aralıgı</SLabelTitle>
          <Flex justify="space-between" gap="small">
            <Flex vertical gap="small" className={globalStyles.widthHalf}>
              <SDatePicker
                id="start_date"
                name="start_date"
                value={
                  values.start_date
                    ? dayjs(values.start_date, DATE_FORMAT)
                    : null
                }
                placeholder="Başlangıç Tarihi"
                onChange={(date) => {
                  if (date) {
                    setFieldValue('start_date', date.format(DATE_FORMAT));
                  }
                }}
              />
              {touched.start_date && errors.start_date && (
                <ErrorMessage>{errors.start_date}</ErrorMessage>
              )}
            </Flex>
            <Flex vertical gap="small" className={globalStyles.widthHalf}>
              <SDatePicker
                id="end_date"
                name="end_date"
                value={
                  values.end_date ? dayjs(values.end_date, DATE_FORMAT) : null
                }
                placeholder="Bitiş Tarihi"
                onChange={(date) => {
                  if (date) {
                    setFieldValue('end_date', date.format(DATE_FORMAT));
                  }
                }}
              />
              {touched.end_date && errors.end_date && (
                <ErrorMessage>{errors.end_date}</ErrorMessage>
              )}
            </Flex>
          </Flex>
        </Flex>
        {props.type === modalTypes.EDIT && organization === 1 && (
          <Flex justify="space-between">
            <SLabelTitle>Durum Bilgisi</SLabelTitle>
            <StatusDropdown
              status={values.recent_status}
              statusChoices={props.statusChoices}
              onChange={(value) => setFieldValue('recent_status', value)}
            />
          </Flex>
        )}
        <Flex vertical gap="small">
          <SLabelTitle>Açıklama</SLabelTitle>
          <Flex vertical>
            <STextArea
              placeholder="Açıklama"
              {...getFieldProps('description')}
              rows={3}
            />
            {touched.description && errors.description && (
              <ErrorMessage>{errors.description}</ErrorMessage>
            )}
          </Flex>
        </Flex>
        {props.type === modalTypes.EDIT && (
          <SMailSelector
            value={values.email_users}
            placeholder="Mail Listesi"
            options={props.withViewPerm?.map((wvp) => ({
              value: wvp.value,
              label: wvp.label,
            }))}
            onChange={(value) => setFieldValue('email_users', value)}
          />
        )}
      </Flex>
    </ModalDialog>
  );
};

export default AbroadInsuranceModal;
